import React, { useEffect } from 'react';
import styles from './index.module.scss';

const CustomDropDown = (props) => {
    useEffect(() => {
        let timing;
        if (props.show) {
            timing = setTimeout(props.hide, 5000);
        }

        return () => {
            clearTimeout(timing)
        }
    }, [props.show, props.hide])

    return (
        <div className={styles.CustomDropDown} style={{ display: props.show ? 'block' : 'none' }}>
            {props.children}
        </div>
    );
};

const Item = (props) => (
    <div className={styles.Item} style={{ color: 'black' }} onClick={props.onClick}>{props.title}</div>
);

CustomDropDown.Item = Item;

export default CustomDropDown;

